import { finleyAssert } from '@finley-technologies/common';

import { DashboardMode } from '../hooks/DataMetadataContextType';
import { colors } from '~/packages/common-frontend/colors';

export type StatusOption = {
  id: DashboardMode;
  label: string;
  value: DashboardMode;
  bgColor?: string;
  headerMessage?: string;
  headerIcon?: string;
  headerIconColor?: string;
};

export type HeaderProps = Pick<
  StatusOption,
  'headerMessage' | 'headerIcon' | 'headerIconColor'
>;

export const ALL_STATUS_OPTIONS: StatusOption[] = [
  { id: 'current', label: 'Current', value: 'current', bgColor: 'white' },
  {
    id: 'preview',
    label: 'Preview WIP',
    value: 'preview',
    bgColor: colors.gray[50],
    headerMessage: 'You are currently previewing the WIP.',
    headerIcon: 'crystal-ball',
    headerIconColor: colors.gray[700],
  },
  {
    id: 'historical',
    label: 'Historical',
    value: 'historical',
    bgColor: colors.millet[100],
    headerMessage: 'You are currently viewing the history.',
  },
];

export const getBgColor = (mode: DashboardMode): string | undefined => {
  return ALL_STATUS_OPTIONS.find((option) => option.id === mode)?.bgColor;
};

export const getBgColorForDashboardMode = (mode: DashboardMode) => {
  return getBgColor(mode);
};

export const getHeaderElementProps = (
  dashboardMode: DashboardMode,
): HeaderProps => {
  const currentOption = ALL_STATUS_OPTIONS.find(
    (option) => option.id === dashboardMode,
  );

  finleyAssert(
    currentOption,
    `Invalid dashboard mode [${dashboardMode}] chosen`,
  );

  return {
    headerMessage: currentOption.headerMessage,
    headerIcon: currentOption.headerIcon,
    headerIconColor: currentOption.headerIconColor,
  };
};
